<template>
  <b-container
    fluid
    :class="{'!tw-px-0': isOnboardingRedesign && step === 'upsell'}"
  >
    <!-- for Desktop Only Progress -->
    <OnboardingProgress
      v-if="step !== 'upsell'"
      :hide="hideBackButton"
      :progress="progress"
      page="checkout"
      @back="prev"
    />
    <template v-if="isOnboardingRedesign && step === 'summary'">
      <portal to="back">
        <b-button
          class="back-btn tw-mr-4"
          size="lg"
          variant="link"
          style="min-width: inherit"
          @click="prev"
        >
          <!-- Back icon -->
          <svg
            width="19"
            height="15"
            viewBox="0 0 19 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.25 7.58594C0.25 7.32149 0.365476 7.08816 0.596428 6.88594L6.9806 0.877604C7.19506 0.68316 7.43839 0.585938 7.71058 0.585938C7.98277 0.585938 8.2096 0.671493 8.39106 0.842604C8.58077 1.01372 8.67563 1.23149 8.67563 1.49594C8.67563 1.62038 8.65088 1.74094 8.60139 1.8576C8.56015 1.97427 8.49417 2.07149 8.40343 2.14927L6.69604 3.8176L2.51416 7.37594L2.29145 6.8626L5.58252 6.64094H17.2621C17.559 6.64094 17.7982 6.73038 17.9797 6.90927C18.1612 7.08816 18.2519 7.31372 18.2519 7.58594C18.2519 7.85816 18.1612 8.08372 17.9797 8.2626C17.7982 8.44149 17.559 8.53094 17.2621 8.53094H5.58252L2.29145 8.30927L2.51416 7.8076L6.69604 11.3543L8.40343 13.0226C8.49417 13.1004 8.56015 13.1976 8.60139 13.3143C8.65088 13.4309 8.67563 13.5515 8.67563 13.6759C8.67563 13.9404 8.58077 14.1582 8.39106 14.3293C8.2096 14.5004 7.98277 14.5859 7.71058 14.5859C7.43839 14.5859 7.19506 14.4887 6.9806 14.2943L0.596428 8.28594C0.365476 8.08372 0.25 7.85038 0.25 7.58594Z"
              fill="#19191C"
            />
          </svg>
        </b-button>
      </portal>
    </template>

    <OnboardingWrapper
      v-if="step !== 'upsell'"
      :has-visible-banner="!['upsell', 'complete', 'shipping-info'].includes(step) && ($_fsaHsaPromo_isActiveFsaHsaPromo || Boolean(coupon.couponid))"
      :page="!['upsell', 'complete'].includes(step) ? 'checkout' : ''"
    >
      <template #header>
        <OnboardingHeader
          v-if="(isOnboardingRedesign && step !== 'summary') || !isOnboardingRedesign"
          :hide="hideBackButton"
          :title="stepTitle"
          @back="prev"
        />
      </template>
      <!-- mobile progress -->
      <MobileOnboardingProgress
        label="Step 3 of 3"
        :start-step=" isOnboardingRedesign ? 'Onboarding Completion' : 'Onboarding Complete'"
        end-step=""
      />
      <b-progress
        :value="mobileProgressDisplay"
        :max="100"
        class="step-progress mb-5"
        :class="isOnboardingRedesign ? 'tw-block md:tw-hidden' : 'd-lg-none'"
        variant="purple"
        height="5px"
      />

      <template v-if="!isOnboardingRedesign">
        <h3
          v-if="step !== 'complete'"
          class="
              d-lg-none
              mt-4
              pb-4
              mb-5
              bold
              d-letter-spacing
              onboarding-title
            "
        >
          <template v-if="step == 'summary'">
            Visit Summary
          </template>
          <template
            v-if="step == 'shipping-info'"
          >
            Shipping Information
          </template>
          <template v-if="step == 'billing'">
            Billing Information
          </template>
        </h3>
      </template>
      <DiscountBanner
        v-if="!$_fsaHsaPromo_isActiveFsaHsaPromo"
        :show="coupon.show"
        :couponid="coupon.couponid"
      />
      <ReferralBanner v-if="!['upsell', 'complete'].includes(step)" />
      <OnboardingCheckoutFormaCodeDiscountBanner />

      <b-alert
        :show="!isOnboardingRedesign && alert.show"
        :variant="alert.type"
      >
        {{
          alert.message
        }}
      </b-alert>
      <Summary
        v-if="step == 'summary'"
        ref="Summary"
        :analytics-id="analyticsId"
        :body="onboardingData"
        :button-disabled="buttonDisabled"
        :saving="buttonDisabled"
        :nonrx="nonrx"
        :selected-pharmacy="selectedPharmacy"
        :pharmacy="pharmacy"
        :onboardingflow="onboardingflow"
        @nextStep="submitPharmacy"
        @clearPharmacy="clearPharmacy"
        @reload-summary="getOnboarding"
        @goToStep="goToStep"
        @showLoader="(...args) => $emit('showLoader', ...args)"
      />
      <!-- <Modal v-if="showM" :body="modalBody" @submitAnswer="submitPharmacy" /> -->
      <PharmacySelect
        v-if="step == 'pharmacy-select'"
        @alert="showAlert"
        @hideAlert="hideAlert"
        @submitAnswer="submitPharmacySelection"
      />
      <Shipping
        v-if="step == 'shipping-info'"
        ref="Shipping"
        :analytics-id="analyticsId"
        :button-disabled="buttonDisabled"
        :saving="buttonDisabled"
        :body="onboardingData"
        :nonrx="nonrx"
        :onboardingflow="onboardingflow"
        :total-price="total"
        @setButtonDisable="setButtonDisable"
        @nextStep="submitShipping"
        @showAlert="showAlert"
      />
      <template v-if="step == 'billing' || billingSkipped">
        <BillingDisplay
          ref="BillingDisplay"
          :body="onboardingData"
          :billing-skipped="billingSkipped"
          :nonrx="nonrx"
          :discount="discount"
          :onboardingflow="onboardingflow"
          :get-onboarding="getOnboarding"
          :analytics-id="analyticsId"
          @set-discount="setDiscount"
          @set-total="setTotal"
        />

        <OnboardingHsaFsaBadge
          class="tw-mb-[1.5rem]"
          :class="{'tw-max-w-[600px] tw-mx-auto': isOnboardingRedesign}"
        />

        <BillingInput
          :body="onboardingData"
          :disabled="buttonDisabled"
          :nonrx="nonrx"
          :total-price="total"
          @showAlert="showAlert"
          @hideAlert="hideAlert"
          @nextStep="submitBilling"
          @update-onboarding="getOnboarding"
          @update-total="total += $event"
        />
      </template>
      <Complete
        v-if="step == 'complete'"
        :analytics-id="analyticsId"
        :nonrx="nonrx"
        :body="onboardingData"
        :total-price="total"
        :couponid="coupon.couponid"
      />
      <div class="tw-mt-3 md:tw-px-10 lg:tw-px-0">
        <ErrorLabel v-if="isOnboardingRedesign && alert.show">
          {{ alert.message }}
        </ErrorLabel>
      </div>
      <div
        v-if="(step == 'billing' || billingSkipped) && !['F3v1', 'F3v2'].includes(onboardingVariant)"
        class="tw-text-center"
      >
        <OnboardingTLSSecurity />
      </div>
    </OnboardingWrapper>
    <template v-if="isOnboardingRedesign">
      <Upsell
        v-if="step == 'upsell'"
        :patient-id="analyticsId"
        @nextStep="nextStep"
      />
    </template>
    <template v-else>
      <AltUpsell
        v-if="step == 'upsell'"
        :couponid="coupon.couponid"
      />
    </template>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
// libs
import { v4 as uuidv4 } from 'uuid';
import _kebabCase from 'lodash/kebabCase'

// services
import { OnboardingService } from '@/services/onboarding.service';

// components
import Summary from '@/components/onboarding/checkout/Summary';
import Shipping from '@/components/onboarding/checkout/Shipping';
import BillingDisplay from '@/components/onboarding/checkout/BillingDisplay';
import BillingInput from '@/components/onboarding/checkout/BillingInput';
import Complete from '@/components/onboarding/checkout/Complete';
import PharmacySelect from '@/components/onboarding/checkout/PharmacySelect';
import OnboardingHeader from '@/components/partials/OnboardingHeader';
import OnboardingWrapper from '@/components/partials/OnboardingWrapper';
import AltUpsell from '@/components/onboarding/checkout/AltUpsell';
import Upsell from '@/components/onboarding/checkout/Upsell';
import OnboardingProgress from '@/components/partials/OnboardingProgress';
import DiscountBanner from '@/components/partials/DiscountBanner';
import OnboardingCheckoutFormaCodeDiscountBanner from '@/components/onboarding/checkout/FormaCodeDiscountBanner';
import OnboardingHsaFsaBadge from '@/components/onboarding/OnboardingHsaFsaBadge.vue';

// constants
import { ONBOARDING_STEP } from '@/constants/localStorage';

// mixins
import analyticsMixin from '@/mixins/analytics';
import { fsaHsaPromoMixin } from '@/mixins/fsaHsaPromo';
import { onboardingCtaFooter } from '@/mixins/onboardingCtaFooter';

import ErrorLabel from '@/components/partials/ErrorLabel.vue';
import OnboardingTLSSecurity from '@/components/onboarding/OnboardingTLSSecurity.vue';
import MobileOnboardingProgress from '@/components/partials/MobileOnboardingProgress.vue';
import ReferralBanner from '@/components/partials/ReferralBanner.vue';

export default {
  components: {
    ReferralBanner,
    MobileOnboardingProgress,
    OnboardingTLSSecurity,
    ErrorLabel,
    Summary,
    Shipping,
    BillingDisplay,
    BillingInput,
    Complete,
    PharmacySelect,
    OnboardingHeader,
    AltUpsell,
    Upsell,
    OnboardingProgress,
    DiscountBanner,
    OnboardingCheckoutFormaCodeDiscountBanner,
    OnboardingHsaFsaBadge,
    OnboardingWrapper
  },
  mixins: [analyticsMixin, fsaHsaPromoMixin, onboardingCtaFooter],
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.global.isModalOpen) {
      next(false);
      return;
    }

    if (
      this.step == 'summary' ||
      to.path == '/' ||
      to.path == '/home' ||
      this.exiting ||
      this.onboardingData.onboardingstep < 5.4
    ) {
      next();
    } else if (
      (this.step == 'complete' || this.step == 'upsell') &&
      to.path == '/identity-verification' &&
      this.onboardingflow == 'flowB'
    ) {
      next();
    } else if (this.step == 'complete' && to.path != '/home') {
      next(false);
    } else {
      this.prev();
      next(false);
    }
  },
  data() {
    return {
      alert: {
        show: false,
        message: '',
      },
      coupon: {
        show: false,
        couponid: '',
      },
      analyticsId: null,
      step: '',
      onboardingData: {},
      nonrx: false,
      selectedPharmacy: false,
      pharmacy: {},
      productIds: [],
      discount: 0,
      total: 0,
      exiting: false,
      buttonDisabled: null,
      onboardingflow: 'flowA',
      city: '',
      zipcode: '',
      address: '',
      revealedProducts: [],
      // for new progress UI update on the header
      progress: [
        {
          title: 'Account Creation',
          value: 100,
          max: 100,
        },
        {
          title: 'Intake',
          value: 5,
          max: 5,
        },
        {
          title: 'Onboarding Completion',
          value: 3,
          max: 5,
        },
      ],
      mobileProgressDisplay: 85,

      billingSkipped: false
    };
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    ...mapState('onboarding', ['onboardingPatient']),
    onboardingVariant() {
      return this.onboardingPatient?.flow_variant;
    },
    hideBackButton() {
      if (this.step !== 'complete') {
        return false;
      }
      return true;
    },
    stepTitle() {
      if (this.step !== 'complete') {
        if (this.step == 'summary') return 'Visit Summary';
        if (this.step == 'shipping-info') return 'Shipping Information';
        if (this.step == 'billing') return 'Billing Information';
      }
      return '';
    },
    showAverageValue() {
      return this.total == 0 || Math.sign(this.total) == -1
    },
  },
  watch: {
    step: {
      handler (step) {
        localStorage.setItem(ONBOARDING_STEP, step);
        this.$emit('setOnboardingStep', step);
        this.updateCouponState();
      },
      // immediate: true
    },
    coupon: {
      handler () {
        this.updateCouponState();
      },
      deep: true,
      immediate: true
    }
  },
  async mounted() {
    this.$_analytics_page();

    this.revealedProducts = await this.$store.dispatch(
      'onboarding/getProductReveal'
    );

    await this.getOnboarding();

    if (this.isOnboardingRedesign) {
      if (this.step === 'upsell') {
        document.documentElement.classList.add('redesign');
      }

      if (this.step === 'complete') {
        window.location.href = '/home';
        return
      }
    }
  },
  methods: {
    setButtonDisable(val) {
      this.buttonDisabled = val;
    },
    showAlert(message, type = null) {
      if (!type) type = 'warning';
      this.alert = {
        show: true,
        type: 'warning',
        message: message,
      };
      if (this.isOnboardingRedesign){
        window.scrollTo(0, document.documentElement.scrollHeight);
      } else {
        window.scrollTo(0, 0);
      }
    },
    hideAlert() {
      this.alert.show = false;
    },
    async getOnboarding() {
      try {
        this.step = localStorage.getItem(ONBOARDING_STEP) || '';
        this.$emit('setOnboardingStep', this.step);

        this.revealedProducts = await this.$store.dispatch(
          'onboarding/getProductReveal'
        );
        this.onboardingData = await this.$store.dispatch(
          'onboarding/getPatientOnboarding'
        );

        if (this.onboardingData.couponid) {
          this.coupon.couponid = this.onboardingData.couponid;
        }

        if (!this.onboardingData?.non_hrt) {
          if (this.onboardingData.onboardingstep < 5.4) {
            this.exiting = true;
            window.location.href = '/';
          }
        }

        if (this.onboardingData.city) {
          this.city = this.onboardingData.city;
        }

        this.analyticsId = this.onboardingData.usercustomid
          ? this.onboardingData.usercustomid
          : this.onboardingData.id;

        // Multiflow
        this.onboardingflow = this.onboardingData.onboardingflow;

        this.nonrx =
          this.onboardingData?.nonrxmedicationonly !== undefined &&
          this.onboardingData.nonrxmedicationonly == true;

        this.total = 0;
        if (this.onboardingData?.desiredplan !== undefined) {
          for (const item of this.onboardingData.desiredplan) {
            this.total = this.total + Math.floor(item.price);
            this.productIds.push(item.productid);
          }
        }
        if (this.onboardingData?.desiredaddon !== undefined) {
          for (const item of this.onboardingData.desiredaddon) {
            this.total = this.total + Math.floor(item.price);
            this.productIds.push(item.productid);
          }
        }

        if (this.onboardingData?.referraldiscountamount !== undefined) {
          if (this.onboardingData.referraldiscountamount) {
            this.total -= this.onboardingData.referraldiscountamount;
          }
        }

        if (this.onboardingData?.couponid !== undefined) {
          this.discount = this.onboardingData.discountbyamount;
          if (this.discount) {
            this.total -= this.discount;
          }
        } else {
          this.discount = 0;
        }

        // Renders a component once data has been loaded in
        if (this.step == '') {
          this.step = 'summary';
        }
      } catch (err) {
        console.error(err);

        if (err.status == 401) {
          this.exiting = true;
          this.$router.push('/login');
        } else {
          this.showAlert(err);
        }
      }
    },

    prev() {
      this.alert.show = false;
      switch (this.step) {
        case 'summary':
          // Multiflow redirection
          if (this.onboardingData.has_completed_non_doc_verification) {
            this.$router.push('/treatment-options').catch(() => {});
          } else {
            this.$router.push('/identity-verification').catch(() => {});
          }
          break;
        case 'pharmacy-select':
          this.step = 'summary';
          break;
        case 'shipping-info':
          this.step = 'summary';
          break;
        case 'billing':
          this.step = 'shipping-info';
          break;
        case 'complete':
          this.step = 'billing';
          break;
      }
    },
    async nextStep() {
      if (this.isOnboardingRedesign) {
        // Used to avoid going to next steps during double clicking of the continue button
        this.onboardingData = await this.$store.dispatch(
          'onboarding/getPatientOnboarding'
        );
        if (this.step === 'shipping-info' && !this.onboardingData?.address1) {
          this.step = 'shipping-info';
          return
        }

        if (this.step === 'billing' && this.onboardingData?.onboardingstep === 7 && this.onboardingData?.onboardingstatus !== 'DONE') {
          this.step = 'billing';
          return
        }
      }
      this.buttonDisabled = false;
      this.alert.show = false;
      switch (this.step) {
        case 'summary':
          if (this.onboardingData?.non_hrt) {
            this.$emit('showLoader', 5, 'doctorvisit');
            this.step = 'shipping-info';
          } else {
            this.step = 'shipping-info';
          }
          break;
        case 'pharmacy-select':
          this.step = 'shipping-info';
          break;
        case 'shipping-info':
          this.step = 'billing';
          break;
        case 'billing': {
          // Multiflow redirection
          $cookies.remove('referralToken');

          const onboardingBlossomPromoCodes = [
            'BLACKFRIDAY2022',
            'CYBERMONDAY2022',
          ];

          if (
            $cookies.get('promocode') &&
            !onboardingBlossomPromoCodes.includes($cookies.get('promocode'))
          ) {
            $cookies.remove('promocode');
          }

          if (this.onboardingflow == 'flowB') {
            this.step = 'upsell';
          } else {
            if (this.isOnboardingRedesign && !this.onboardingPatient?.non_hrt) {
              this.step = 'upsell'
            } else {
              this.step = 'complete';
            }
          }
          break;
        }
        case 'upsell':
          this.step = 'complete';
          break;
      }
    },
    goToStep(step) {
      this.step = step;
    },
    async submitShipping(answers, paymentMethod) {
      this.buttonDisabled = true;
      try {
        this.alert.show = false;
        this.city = answers.city;
        this.zipcode = answers.zipcode;
        this.address = answers.address1;
        await OnboardingService.updatePatientOnboarding(
          6,
          answers
        );

        if (paymentMethod) {
          this.billingSkipped = true;
          const billingAnswer = {
            paymentmethod: typeof paymentMethod === 'string' ? paymentMethod : paymentMethod.id,
            sameaddress: true
          }
          await this.submitBilling(billingAnswer, true)
          if (this.isOnboardingRedesign && !this.onboardingPatient?.non_hrt) {
            this.step = 'upsell';
          } else {
            this.step = 'complete';
          }
          this.billingSkipped = false;
          return
        }

        this.nextStep();
      } catch (err) {
        if (err.response.status == 401) {
          this.exiting = true;
          this.$router.push('/login');
        } else {
          this.buttonDisabled = false;
          if (
            err.response.data.message ==
            'Could not match zip code, city and state'
          ) {
            if (err.response?.data?.body?.addresses?.length > 0) {
              this.$refs.Shipping.showSideModal = true;
              this.$refs.Shipping.suggestedAddresses =
                this.$refs.Shipping.suggestedAddresses.concat(
                  err.response?.data?.body?.addresses
                );
            } else {
              this.$refs.Shipping.showModal = true;
            }
          } else {
            const id = this.onboardingData.id
              ? this.onboardingData.id
              : 'Could not get customer ID';
            const email = this.onboardingData.email
              ? this.onboardingData.email
              : 'Could not get customer email';
            this.$store.dispatch('sendErrorLog', {
              step: 'Checkout - Shipping',
              cus_id: id,
              email: email,
              error_log: err.response.data.message,
            });
            this.showAlert(err.response.data.message);
          }
        }
      } finally {
        this.buttonDisabled = false;
      }
    },
    async submitBilling(answer, isSkipBilling) {
      this.buttonDisabled = true;
      try {
        // Supplies message to turn on manual toggling
        this.$emit('showLoader', 6, 'lottie');

        await this.$_analytics_track(
          'Onboarding Screen Viewed',
          {
            customerId: this.analyticsId,
            screen: '5.4-A',
            onboardingflow: this.onboardingflow,
            state: this.onboardingData.state,
            firstname: this.onboardingData.firstname,
            lastname: this.onboardingData.lastname,
          },
        );

        // Checkout ID
        const checkoutID = uuidv4();
        answer.checkoutID = checkoutID;
        const data = await OnboardingService.updatePatientOnboarding(7, answer);

        const productids = [];
        let price = 0;
        if (
          this.onboardingData.desiredaddon &&
          this.onboardingData.desiredaddon.length > 0
        ) {
          for (const addon of this.onboardingData.desiredaddon) {
            price = price + Math.floor(addon.price);
            productids.push(addon.productid);
          }
        }

        if (
          this.onboardingData.desiredplan &&
          this.onboardingData.desiredplan.length > 0
        ) {
          for (const plan of this.onboardingData.desiredplan) {
            price = price + Math.floor(plan.price);
            productids.push(plan.productid);
          }
        }

        if (tatari) {
          // WIN-23503
          tatari.track('purchase', {
            orderId: data.data.eventid,
            total: this.showAverageValue ? 160 : this.total,
          });
          console.log('Tatari Track: Purchase', {
            orderId: data.data.eventid,
            total: this.showAverageValue ? 160 : this.total,
          });
        }

        console.log('SEGMENT', {
          messageId: data.data.eventid,
          productids: productids,
          subtotal: this.$refs.BillingDisplay.subtotal,
          platformfee: this.$refs.BillingDisplay.platformfee,
          taxamount: this.$refs.BillingDisplay.taxamount,
          grandtotal: Math.sign(this.total) == -1 ? 0 : this.total,
          customerId: this.analyticsId,
          value: this.showAverageValue ? 160 : this.total,
        });

        let products = {};
        if ('desiredplan' in this.onboardingData && this.onboardingData.desiredplan.length > 0) {
          // WIN-53617
          products = {
            // this.revealedProducts
            // this.onboardingData.desiredplan
            products: this.onboardingData.desiredplan
              .filter(plan => plan.pricingdetail && plan.pricingdetail.pricingid)
              .map(plan => {
                const productObj = this.revealedProducts.find(product => plan.productid === product.id)

                return {
                  name: productObj?.previousproductname || productObj.name,
                  product_id: productObj.id,
                  sku: productObj.id,
                  price: productObj.availablepricing.find(pricing => pricing.pricingid === plan.pricingdetail.pricingid).price,
                  url: `${process.env.VUE_APP_WEBSITE_URL}/product/${_kebabCase(productObj.name)}`,
                  image_url: productObj.image,
                  category: this.onboardingPatient?.non_hrt ? 'add_on' : 'core_products',
                  type: this.onboardingPatient?.non_hrt ? 'Non-HRT' : undefined,
                }
              })
          }
        }

        await this.$_analytics_track(
          'Checkout Complete',
          {
            checkoutID: checkoutID,
            messageID: data.data.eventid,
            productids: productids,
            subtotal: this.$refs.BillingDisplay.subtotal,
            platformfee: this.$refs.BillingDisplay.platformfee,
            taxamount: this.$refs.BillingDisplay.taxamount,
            // WIN-24812
            grandtotal: Math.sign(this.total) == -1 ? 0 : this.total,
            revenue: this.showAverageValue ? 16900 : (Math.round(this.total * 100)),
            // WIN-29811
            total: this.showAverageValue ? 187 : this.total,
            value: this.showAverageValue ? 160 : this.total,
            customerId: this.analyticsId,
            onboardingflow: this.onboardingflow,
            email: this.onboardingData.email,
            phone: this.onboardingData.phoneno,
            state: this.onboardingData.state,
            zipcode: this.zipcode,
            address: this.address,
            firstname: this.onboardingData.firstname,
            lastname: this.onboardingData.lastname,
            couponCode: this.coupon.couponid ? this.coupon.couponid : null,
            ...products,
            currency: 'USD',
            category: this.onboardingPatient?.non_hrt ? 'add_on' : 'core_products',
            type: this.onboardingPatient?.non_hrt ? 'Non-HRT' : undefined,
          },
        );
        
        if (
          (this.onboardingData.identificationupload === 'UPLOADED' && this.onboardingData.photoupload === 'UPLOADED') ||
          this.onboardingData.has_completed_non_doc_verification == true
        ) {
          await this.$_analytics_track(
            'Onboarding Complete',
            {
              name: `${this.onboardingData.firstname.toLowerCase()} ${this.onboardingData.lastname.toLowerCase()}`,
              firstName: this.onboardingData.firstname.toLowerCase(),
              lastName: this.onboardingData.lastname.toLowerCase(),
              email: this.onboardingData.email.toLowerCase(),
              phone: this.onboardingData.phoneno,
              city: this.city.toLowerCase(),
              state: this.onboardingData.state.toLowerCase(),
              birthday: this.onboardingData.birthday,
              gender: this.onboardingData.gender == 'Female' ? 'f' : 'm',
              country: 'us',
              address: {
                address: this.address.toLowerCase(),
                city: this.city.toLowerCase(),
                state: this.onboardingData.state.toLowerCase(),
                zip: this.zipcode,
              },
            }
          )
        }

        // Reboot intercom to hide "Schedule a meeting" component
        window.Intercom('shutdown')
        window.Intercom('boot', {
          app_id: process.env.VUE_APP_INTERCOM_APP_ID,
          user_id: this.onboardingData.id
        });

        // GTM productObj
        const productObj = [];
        const productItems = [];
        if (this.onboardingData?.desiredplan !== undefined) {
          for (const item of this.onboardingData.desiredplan) {
            const toPush = {
              id: item.productid,
              name: item.name,
              price: item.price,
            };
            productObj.push(toPush);
            const itemObj = {
              item_name: item.name,
              item_id: item.productid,
              quantity: 1,
              price: item.price,
            }
            productItems.push(itemObj);
          }
        }
        // Logging for GTM testing purposes
        console.log('productObj', productObj);
        console.log('items property', productItems);
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
          productObj: productObj,
          items: productItems,
        });

        console.log('Purchase', {
          external_id: this.onboardingData.id,
          productID: productids,
          currency: 'USD',
          value: this.total,
        });
        if (data.data.eventid) {
          /*
           * Ensure that purchase events are above $0 as FB
           * doesn't like it when Purchase events have a value of 0.
           */

          if (this.total == 0 || !this.total) {
            this.total = 1;
          }
          await this.fbqTrack(
            'track',
            'Purchase',
            productids,
            this.total,
            data.data.eventid
          );
        } else if (
          data.data.eventid &&
          process.env.VUE_APP_SERVER != 'production'
        ) {
          // alert('FB TRACKING PURCHASE: ' + data.data.eventid);
          console.log('FB TRACKING PURCHASE');
          console.log('FB TRACKING PURCHASE: ' + data.data.eventid);
        }

        this.$emit('hideLoader');

        if (isSkipBilling) {
          return
        }

        this.nextStep();
      } catch (err) {
        this.$emit('hideLoader');

        await this.$_analytics_track(
          'Onboarding Screen Viewed',
          {
            customerId: this.analyticsId,
            screen: '5.3-A',
            onboardingflow: this.onboardingflow,
            firstname: this.onboardingData.firstname,
            lastname: this.onboardingData.lastname,
          },
        );
        console.error(err);

        const id = this.onboardingData.id
          ? this.onboardingData.id
          : 'Could not get customer ID';
        const email = this.onboardingData.email
          ? this.onboardingData.email
          : 'Could not get customer email';
        this.$store.dispatch('sendErrorLog', {
          step: 'Checkout - Billing Details',
          cus_id: id,
          email: email,
          error_log: err,
        });
        this.buttonDisabled = false;
        this.showAlert(err);
      }
    },
    async fbqTrack(type, eventName, productids, price, eventID) {
      try {
        // FB Pixel Tracking
        fbq('init', '348219289912097', {
          em: this.onboardingData.email, //Values will be hashed automatically by the pixel using SHA-256
          fn: this.onboardingData.firstname,
          ln: this.onboardingData.lastname,
          ph: this.onboardingData.phoneno,
          external_id: this.onboardingData.id,
          extern_id: this.onboardingData.id,
        });
        // fbq("track", "PageView");
        const pageViewBody = { userid: this.onboardingData.userid };
        OnboardingService.onboardingEvent('PageView', pageViewBody);
        fbq(
          type,
          eventName,
          {
            external_id: this.onboardingData.id,
            extern_id: this.onboardingData.id,
            productID: productids,
            currency: 'USD',
            value: price,
            state: this.onboardingData.state,
            ...(this.city && { city: this.city }),
            ...(await this.$store.dispatch('getFBQParams')),
          },
          {
            eventID: eventID,
          }
        );
      } catch (err) {
        console.log(err);
      }
    },
    async submitPharmacy() {
      this.buttonDisabled = true;
      await this.getOnboarding();
      console.log('InitiateCheckout', {
        external_id: this.onboardingData.id,
        productID: this.productIds,
        currency: 'USD',
        value: this.total,
      });
      try {
        const productids = [];
        let price = 0;
        if (
          this.onboardingData.desiredaddon &&
          this.onboardingData.desiredaddon.length > 0
        ) {
          for (const addon of this.onboardingData.desiredaddon) {
            price = price + Math.floor(addon.price);
            productids.push(addon.productid);
          }
        }

        if (
          this.onboardingData.desiredplan &&
          this.onboardingData.desiredplan.length > 0
        ) {
          for (const plan of this.onboardingData.desiredplan) {
            price = price + Math.floor(plan.price);
            productids.push(plan.productid);
          }
        }

        if (this.onboardingData.onboardingstep === 5.4) {
          try {
            const eventCheckoutstarted =
              OnboardingService.triggerOnboardingEvents({
                eventname: 'CheckoutStarted',
                path: window.location.pathname,
              });

            if (eventCheckoutstarted.data.status === 'new') {
              if (eventCheckoutstarted.data.id) {
                await this.fbqTrack(
                  'trackCustom',
                  'InitiateCheckout',
                  productids,
                  price,
                  eventCheckoutstarted.data.id
                );
              } else if (
                eventCheckoutstarted.data.id &&
                process.env.VUE_APP_SERVER != 'production'
              ) {
                // alert('FB TRACKING InitiateCheckout: ' + eventCheckoutstarted.data.id);
                console.log('FB TRACKING InitiateCheckout');
                console.log(
                  'FB TRACKING InitiateCheckout: ' +
                    eventCheckoutstarted.data.id
                );
              }
            }
          } catch (err) {
            // Error handling for integromat event
          }
        }

        try {
          await OnboardingService.updatePatientOnboarding(
            5.4,
            {
              pharmacyid: '',
              agreedtorisks: true,
            }
          );
        } catch (err) {
          if (err.status == 401) {
            this.exiting = true;
            this.$router.push('/login');
          } else {
            this.buttonDisabled = false;
            this.showAlert(err);
          }
        }
        this.nextStep();
      } catch (err) {
        console.log({ err })
      } finally {
        this.buttonDisabled = false;
      }
    },
    async submitPharmacySelection(answer) {
      this.onboardingData.pharmacyid = answer.PharmacyId;
      this.pharmacy = answer;
      this.selectedPharmacy = true;
      this.step = 'summary';
    },
    clearPharmacy() {
      this.pharmacy = {};
      this.selectedPharmacy = false;
    },
    setTotal(total) {
      this.total = total;
    },
    setDiscount(discount) {
      this.discount = discount;
    },
    updateCouponState() {
      switch (this.step) {
        case 'summary':
          this.mobileProgressDisplay = 85;
          if (this.coupon.couponid) {
            this.coupon.show = true;
          }
          this.onboardingflow === 'flowA' ? 85 : 70;
          this.onboardingflow === 'flowA'
            ? this.$set(this.progress[2], 'value', 3)
            : this.$set(this.progress[2], 'value', 2);
          break;
        case 'shipping-info':
          this.coupon.show = false;
          this.mobileProgressDisplay = this.onboardingflow === 'flowA' ? 90 : 75;
          this.onboardingflow === 'flowA'
            ? this.$set(this.progress[2], 'value', 3.5)
            : this.$set(this.progress[2], 'value', 2.4);
          break;
        case 'billing':
          if (this.coupon.couponid) {
            this.coupon.show = true;
          }
          this.mobileProgressDisplay = this.onboardingflow === 'flowA' ? 95 : 80;
          this.onboardingflow === 'flowA'
            ? this.$set(this.progress[2], 'value', 4)
            : this.$set(this.progress[2], 'value', 2.8);
          break;
        case 'complete':
          this.coupon.show = false;
          this.mobileProgressDisplay = 100;
          this.$set(this.progress[2], 'value', 5);
          break;
      }
    },
  },
};
</script>
